<template>
    <div class="modal-card">
        <header class="modal-card-head has-bg-info">
            <p class="modal-card-title">{{$t('MODALRESUMOCLIENTE.GERADOPORIA')}}</p>
        </header>
        <section class="modal-card-body is-paddingless" style="overflow: hidden;">
            <div class="panel">
                <p class="panel-block">
                    <b-field :label="$t('MODALRESUMOCLIENTE.RESUMODOCLIENTE')"></b-field>
                </p>
                <div class="panel-block">
                    <div v-if="isLoading">
                        <b-loading :is-full-page="false" active></b-loading>
                    </div>
                    <div 
                        v-else
                        class="textarea" 
                        v-html="resumoDoCliente"
                        readonly
                    ></div>
                </div>
            </div>
        </section>
        <footer class="modal-card-foot">
            <b-button @click="abrirPdf()" v-if="resumoDoCliente" icon-left="eye" type="is-info">{{$t('SISTEMA.PDF')}}</b-button>  
            <b-button @click="$emit('close')">{{$t('SISTEMA.CANCELAR')}}</b-button>
        </footer>
    </div>
</template>


<style scoped>
    .textarea {
        display: block;
        width: 100%;
        min-height: 500px !important;
        padding: 0.625em;
        border: 1px solid #dbdbdb;
        border-radius: 4px;
        background-color: #fff;
        white-space: pre-wrap;
        overflow-y: auto;
        font-family: inherit;
        font-size: inherit;
        color: inherit;
    }
</style>

<script>
    import LZString from 'lz-string';
          
    export default {
   
        props: {
            clienteNome: String,
            historicoAlteracoes: Array
        },
        data() {
            return {
                resumoDoCliente: null,
                isLoading :false,
            }
        },
        async created() {
            await this.gerarResumoCliente();
        },
        methods: {
            gerarResumoCliente(){
                this.isLoading = true;
                
                this.$http.post(`/api/integracao/GerarResumoCliente?clienteNome=${this.clienteNome}`, this.historicoAlteracoes)
                .then(res => res.data)
                .then(data => {
                    this.resumoDoCliente = data;
                })
                .catch((error) => {    
                    this.$buefy.toast.open({
                        duration: 5000,
                        message: this.$t('MODALRESUMOCLIENTE.ERROAOGERARRESUMO'),
                        type: 'is-danger',
                        queue: false
                    });                                                    
                    throw error;
                })
                .finally(() => {
                    this.isLoading = false;
                });
            },
            abrirPdf(){
      
                const textoCompactado = LZString.compressToEncodedURIComponent(this.resumoDoCliente);
                const url = `/api/atendimento/ResumoClienteGeradoPDF?resumoDoCliente=${textoCompactado}`;
                window.open(url, "_blank");
            },
        }
    }
</script>